import { type TypePolicy } from '@apollo/client';

// A per-locale view with no identity of its own, so it stays nested under the query field.
export const PublicAgreement: TypePolicy = {
    keyFields: false,
};
